module.exports = __webpack_public_path__ + "img/nav-appointment@2x.a71c85b.webp";